import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { getHasReferralsR2M } from "@faire/retailer-visitor-shared/serialized-data/getHasReferralsR2M";
import { assignSettingR2BAwardConfiguration } from "@faire/retailer-visitor-shared/settings/getSettingR2BAwardConfiguration";
import { useR2BAwardStore } from "@faire/retailer-visitor-shared/stores/domain/useR2BAwardStore";
import { trackEvent, trackEventOnClick } from "@faire/web--source/common/trackEvent";
import { Button } from "@faire/web--source/slate/Button";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { TypographyStyles } from "@faire/web--source/ui/Typography";
import userBrandReferrals from "@faire/web-api--source/routes/www/user/brand-referrals";
import * as React from "react";
import { useEffect } from "react";
import styled from "styled-components";
export var RetailerToMakerReferral = function() {
    useEffect(function() {
        assignSettingR2BAwardConfiguration();
    }, []);
    var hasReferralsR2M = getHasReferralsR2M();
    var retailerToken = useRetailer().retailerToken;
    var r2bAdvertisedRetailerAwardFormatted = useR2BAwardStore().r2bAdvertisedRetailerAwardFormatted;
    var ref = useDoActionWhenVisible(function() {
        trackEvent("".concat(hasReferralsR2M ? "returning" : "new", "/retailer/").concat(retailerToken, "/show/footer"));
    });
    return /*#__PURE__*/ _jsxs(Container, {
        ref: ref,
        children: [
            /*#__PURE__*/ _jsx(Text, {
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "DjxGj3",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Earn up to "
                        },
                        {
                            type: 1,
                            value: "amountMoney"
                        },
                        {
                            type: 0,
                            value: " for every brand you refer to Faire."
                        }
                    ],
                    values: {
                        amountMoney: r2bAdvertisedRetailerAwardFormatted
                    }
                })
            }),
            /*#__PURE__*/ _jsx(ReferButton, {
                linkTo: userBrandReferrals(),
                onClick: trackEventOnClick("retailer-to-maker/entry/footer/".concat(hasReferralsR2M ? "returning" : "new", "/retailer/").concat(retailerToken)),
                variant: "secondary",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "SITvsV",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Refer Today"
                        }
                    ]
                })
            })
        ]
    });
};
var Container = styled.section.withConfig({
    componentId: "sc-8b35546f-0"
})([
    "display:flex;flex-direction:column;align-self:stretch;align-items:stretch;justify-content:flex-start;border-top:1px solid ",
    ";padding:32px 24px;",
    "{padding:30px 96px 60px;border-top-color:transparent;}",
    "{max-width:429px;padding:24px 96px 60px 0;align-items:flex-end;}",
    "{max-width:530px;}"
], Core.border.muted, responsiveMediaQueries.tabletAndAbove, responsiveMediaQueries.desktopAndAbove, responsiveMediaQueries.xLargeAndAbove);
var Text = styled.h3.withConfig({
    componentId: "sc-8b35546f-1"
})([
    "",
    ";max-width:255px;margin:0;",
    "{max-width:100%;}"
], TypographyStyles({
    h4: true,
    serif: true
}), responsiveMediaQueries.tabletAndAbove);
var ReferButton = styled(Button).withConfig({
    componentId: "sc-8b35546f-2"
})([
    "min-width:200px;width:fit-content;margin-top:15px;"
]);
